import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-ink text-pearl mt-24" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <h3 className="font-serif-display text-5xl tracking-[0.2em] uppercase mb-4">MODA</h3>
          <p className="text-pearl/60 max-w-sm leading-relaxed text-sm">
            Considered wardrobe essentials for the modern woman. Designed in small runs, made to be worn for years.
          </p>
        </div>
        <div>
          <p className="label-caps text-pearl/40 mb-4">Shop</p>
          <ul className="space-y-2 text-sm text-pearl/70">
            <li><Link to="/shop?category=Dresses" className="hover:text-pearl transition-colors">Dresses</Link></li>
            <li><Link to="/shop?category=Tops" className="hover:text-pearl transition-colors">Tops</Link></li>
            <li><Link to="/shop?category=Outerwear" className="hover:text-pearl transition-colors">Outerwear</Link></li>
            <li><Link to="/shop?category=Bottoms" className="hover:text-pearl transition-colors">Bottoms</Link></li>
          </ul>
        </div>
        <div>
          <p className="label-caps text-pearl/40 mb-4">Connect</p>
          <a href="https://instagram.com/moda.ps" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-sm text-pearl/70 hover:text-pearl transition-colors" data-testid="footer-instagram">
            <Instagram strokeWidth={1.5} className="w-4 h-4" /> @moda.ps
          </a>
        </div>
      </div>
      <div className="border-t border-pearl/10 py-6 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 label-caps text-pearl/40">
        <span>© 2026 MODA — Crafted with care</span>
        <Link to="/login" className="hover:text-pearl transition-colors" data-testid="footer-admin-link">Store admin</Link>
      </div>
    </footer>
  );
}
